export const contactHero = {
  badge: "Contact Us",
  title: "Get in Touch",
  subtitle:
    "Whether you have a question about our programmes, want to explore a partnership, or need support - our team is ready to help. Reach out and we will respond within 48 hours.",
};

export const contactDetails = [
  {
    icon: "ri-map-pin-line",
    title: "Office Address",
    lines: [
      "47, Road 3, Sector 13",
      "Uttara, Dhaka, Bangladesh",
    ],
  },
  {
    icon: "ri-phone-line",
    title: "Phone",
    lines: ["+880 1717-190567"],
    note: "Mon-Fri, 9:00 AM - 6:00 PM BDT",
  },
  {
    icon: "ri-mail-line",
    title: "Email",
    lines: ["info@textileinnovationexchange.com"],
    note: "General enquiries",
  },
  {
    icon: "ri-briefcase-line",
    title: "Partnership",
    lines: ["sales@textileinnovationexchange.com"],
    note: "Business & collaboration",
  },
];

export const officeHours = {
  weekdays: "Saturday - Thursday: 9:00 AM - 6:00 PM BDT",
  friday: "Friday: Closed",
  support: "Email support available 24/7",
};

export const contactSubjects = [
  "General Enquiry",
  "Partnership Opportunity",
  "Programme Registration",
  "Media & Press",
  "Research Collaboration",
  "Event Sponsorship",
  "Support & Feedback",
  "Other",
];